import FaqAccordians from "./faq-accordians";
import FaqCta from "./faq-cta";

export { FaqAccordians, FaqCta };